import 'flickity/dist/flickity.pkgd'

const logosSlider = jQuery('.fp-logos__holder'),
    logosSlide = jQuery('.fp-logos__holder .fp-logos__logo')

if (logosSlider.length > 0 && logosSlide.length > 1) {

    logosSlider.flickity({
        cellSelector : '.fp-logos__logo',
        wrapAround   : false,
        cellAlign    : 'left',
        groupCells   : true,
        autoPlay     : false,
        draggable    : true,
        arrowShape   : {
            x0: 30,
            x1: 55, y1: 30,
            x2: 65, y2: 30,
            x3: 40
        },
    })
}

const productsSlider = jQuery('.fp-products__holder'),
    productsSlide = jQuery('.fp-products__holder .product')

if (productsSlider.length > 0 && productsSlide.length > 1) {

    productsSlider.flickity({
        cellSelector : '.product',
        wrapAround   : false,
        cellAlign    : 'left',
        groupCells   : true,
        autoPlay     : false,
        draggable    : true,
        arrowShape   : {
            x0: 30,
            x1: 55, y1: 30,
            x2: 65, y2: 30,
            x3: 40
        },
    })
}

const testimonialsSlider = jQuery('.fp-reviews__holder'),
    testimonialsSlide = jQuery('.fp-reviews__holder .fp-reviews__block')

if (testimonialsSlider.length > 0 && testimonialsSlide.length > 1) {

    testimonialsSlider.flickity({
        cellSelector : '.fp-reviews__block',
        wrapAround   : false,
        cellAlign    : 'left',
        groupCells   : true,
        autoPlay     : false,
        draggable    : true,
        arrowShape   : {
            x0: 30,
            x1: 55, y1: 30,
            x2: 65, y2: 30,
            x3: 40
        },
    })
}


if(jQuery(window).width() >= '1024'){
    if ( jQuery(".fp-products__holder .flickity-prev-next-button.previous").is(":disabled") && jQuery(".fp-products__holder .flickity-prev-next-button.next").is(":disabled") ) {
        jQuery(".fp-products__holder").addClass('flickity-arrows-disabled')
     }

    if ( jQuery(".fp-reviews__holder .flickity-prev-next-button.previous").is(":disabled") && jQuery(".fp-reviews__holder .flickity-prev-next-button.next").is(":disabled") ) {
        jQuery(".fp-reviews__holder").addClass('flickity-arrows-disabled')
    }

    if ( jQuery(".fp-logos__holder .flickity-prev-next-button.previous").is(":disabled") && jQuery(".fp-logos__holder .flickity-prev-next-button.next").is(":disabled") ) {
        jQuery(".fp-logos__holder").addClass('flickity-arrows-disabled')
    }
}


jQuery(window).on('resize', function(){
    // testimonialsSlider.resize();
    if(jQuery(window).width() >= '1024'){
        if ( jQuery(".fp-products__holder .flickity-prev-next-button.previous").is(":disabled") && jQuery(".fp-products__holder .flickity-prev-next-button.next").is(":disabled") ) {
            jQuery(".fp-products__holder").addClass('flickity-arrows-disabled')
         }

        if ( jQuery(".fp-reviews__holder .flickity-prev-next-button.previous").is(":disabled") && jQuery(".fp-reviews__holder .flickity-prev-next-button.next").is(":disabled") ) {
            jQuery(".fp-reviews__holder").addClass('flickity-arrows-disabled')
        }

        if ( jQuery(".fp-logos__holder .flickity-prev-next-button.previous").is(":disabled") && jQuery(".fp-logos__holder .flickity-prev-next-button.next").is(":disabled") ) {
            jQuery(".fp-logos__holder").addClass('flickity-arrows-disabled')
        }
    } else {
        jQuery(".fp-logos__holder").removeClass('flickity-arrows-disabled')
        jQuery(".fp-reviews__holder").removeClass('flickity-arrows-disabled')
        jQuery(".fp-products__holder").removeClass('flickity-arrows-disabled')
    }

});
